type SentryRuntimeContext = {
  hostname: string;
  environment: string | undefined;
  isCypress: boolean;
};

const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '[::1]']);

export const shouldSendSentryEvent = ({
  hostname,
  environment,
  isCypress,
}: SentryRuntimeContext): boolean => {
  if (isCypress) {
    return false;
  }

  const isLocalHost = LOCAL_HOSTNAMES.has(hostname);

  // `yarn build && yarn preview` embeds environment=production. Cypress and
  // local previews must not create production issues from localhost.
  if (isLocalHost && (environment === 'production' || environment === undefined)) {
    return false;
  }

  return true;
};
